import React, { Children, useEffect, useState } from 'react';
import useMeasure from 'react-use-measure';
import { ResizeObserver } from '@juggle/resize-observer';
import mergeRefs from 'react-merge-refs';
import { useGesture } from 'react-use-gesture';
import useOffset from './useOffset';
import {
  ElementsContainer,
  Gradients,
  PillScrollContainer,
  Positioner,
  Shadows,
  Wrapper,
} from './markup';
import useScrollToCurrentSection from './useScrollToCurrentSection';
import navStore from './navStore';

const Pill = ({ children }) => {
  const { linkWidth, stickyScroll } = navStore(state => state.config);

  const [down, setDown] = useState<any>(false);
  const [left, setLeft] = useState<any>(0);
  const [scrolling, setScrolling] = useState<any>(0);

  const [mRef, { width }] = useMeasure({ polyfill: ResizeObserver });

  const getOffset = useOffset(width);

  const bind = useGesture({
    onDrag: state => setDown(state.down),
    onScroll: state => {
      setScrolling(state.scrolling);
      setLeft(state.xy[0]);
    },
  });

  const ref = useScrollToCurrentSection(width);

  useEffect(() => {
    if (!stickyScroll) return;
    if (!(down || scrolling)) {
      const cS =
        left <= 0
          ? 0
          : left >= Children.count(children) * linkWidth - width
          ? Children.count(children) - 1
          : Math.floor((left + width / 2) / linkWidth);
      ref.current?.scrollTo({
        left: getOffset(cS),
        behavior: 'smooth',
      });
    }
  }, [
    children,
    stickyScroll,
    linkWidth,
    ref,
    getOffset,
    down,
    left,
    scrolling,
    width,
  ]);

  return (
    <Positioner>
      <Wrapper>
        <Shadows />
        <PillScrollContainer {...bind()} ref={mergeRefs([ref, mRef])}>
          <ElementsContainer>{children}</ElementsContainer>
        </PillScrollContainer>
        <Gradients />
      </Wrapper>
    </Positioner>
  );
};

export default Pill;
